// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"35b25d07","148":"8ade2fc0","255":"ab86d8e3","444":"706b8444","635":"3a005130","707":"a2e4b9e8","943":"ffa6f619"}[chunkId] + ".chunk.js";
};